import { LOCAL_STORAGE_KEYS } from "@/constant/keys";
import GlobalStyle from "@/globalStyle";
import CalendarPage from "@/page/calendar";
import DevProfileSetting from "@/page/devProfileSetting";
import MatchPage from "@/page/match";
import { CurrentUserProvider, useCurrentUser } from "@/provider/currentUser";
import { issueMiniAppSignedToken } from "@api/miniApp";
import { fetchGroupTheme } from "@api/moimAPI";
import {
  makeTheme,
  elementThemePaletteGenerator,
  UserStatusTypes,
} from "@moim/common";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import WebApp from "@twa-dev/sdk";
import { DefaultTheme, ThemeProvider } from "styled-components";
import { Router, Switch, Route, Link, useLocation } from "wouter";
import React from "react";
import { IntlProvider } from "react-intl";
import JoinTeams, { IHandler } from "./common/components/JoinTeams";
import useTelegramNavigationObserver from "./common/hooks/useTelegramNavigationObserver";
import SelectTeamPage from "./dialog";
import ProfilePage from "./page/profile";

const queryClient = new QueryClient();

function App() {
  const ref = React.useRef<IHandler>(null);
  const [, setLocation] = useLocation();
  const { setCurrentUser } = useCurrentUser();
  const [isProcessing, setProcessing] = React.useState(false);
  const isAlreadySigned = Boolean(
    localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN),
  );

  const telegramUserSignup = React.useCallback(async () => {
    const initData = WebApp.initData;
    if (!isAlreadySigned && initData) {
      setProcessing(true);
      try {
        const { user } = await issueMiniAppSignedToken(initData);
        if (user) {
          console.log(`boseok_debug log 2 user is : `, user);
          localStorage.setItem(
            LOCAL_STORAGE_KEYS.SIGNED_USER,
            JSON.stringify(user),
          );
          setCurrentUser?.(user);
          // ref.current?.onOpen();
          if (user?.status === UserStatusTypes.PENDING) {
            setLocation("/team-select");
          }
        }
      } catch (err) {
        console.error(`err : ${err}`);
      } finally {
        setProcessing(false);
      }
    }
  }, []);
  setLocation("/team-select");
  useTelegramNavigationObserver();

  React.useEffect(() => {
    console.log("boseok_debug log 1");
    telegramUserSignup();
  }, []);

  React.useEffect(() => {});

  if (isProcessing) {
    return <div>Now processing... Telegram user authenticate</div>;
  }

  return isAlreadySigned ? (
    <>
      <Switch>
        <Route path="/">
          <div
            style={{
              width: "100%",
              height: "100%",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Link to="/match">
              ➡️ [12.14 Fulham vs Liverpool] Match 바로가기
            </Link>
            <Link to="/calendar">➡️ Calendar Show</Link>
            <Link to="/profile">➡️ Profile</Link>
            <Link to="/dev-profile-setting">➡️ Profile debug</Link>
            {/* <button
              style={{ textAlign: "left" }}
              onClick={() => {
                ref.current?.onOpen();
              }}
            >
              ➡️ 마이팀 변경하기(Dev only)
            </button> */}
          </div>
        </Route>
        <Route path="/match" component={MatchPage} />
        <Route
          path="/forums/:forumId/threads/:threadId"
          component={MatchPage}
        />

        <Route path="/calendar" component={CalendarPage} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/dev-profile-setting" component={DevProfileSetting} />
        <Route path="/team-select" component={SelectTeamPage} />
        <Route>404</Route>
      </Switch>
      <JoinTeams ref={ref} />
    </>
  ) : (
    <div>localStorage나 API통해서 유저를 가져오지 못한 것 같습니다.</div>
  );
}

export default function WrappedApp() {
  const [isLoading, setLoadStatus] = React.useState(false);
  const [themeMode, setThemeMode] =
    React.useState<Moim.Enums.ThemeModeType>("DARK");
  const [theme, setTheme] = React.useState<DefaultTheme>();

  const changeThemeMode = React.useCallback(
    (mode: Moim.Enums.ThemeModeType) => {
      setThemeMode(mode);
    },
    [],
  );

  const initializeTheme = React.useCallback(async () => {
    try {
      setLoadStatus(true);
      const response = await fetchGroupTheme();
      const elementThemePalette = elementThemePaletteGenerator(
        response.palette,
        response.element,
      );
      const theme = makeTheme({
        themeMode,
        setThemeMode: changeThemeMode,
        locale: window.navigator.language,
        palette: response.palette,
        darkPalette: response.darkPalette,
        systemColor: response.systemColor,
        darkSystemColor: response.darkSystemColor,
        elementThemePalette: elementThemePalette,
      });
      setTheme(theme as unknown as DefaultTheme);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadStatus(false);
    }
  }, []);

  React.useEffect(() => {
    initializeTheme();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {isLoading || !theme ? (
        <div>theme Loading...</div>
      ) : (
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <React.Suspense>
            <Router>
              <IntlProvider locale="ko" messages={{}}>
                <CurrentUserProvider>
                  <App />
                </CurrentUserProvider>
              </IntlProvider>
            </Router>
          </React.Suspense>
        </ThemeProvider>
      )}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

/// Moim.Blockit.Blocks[]인 블럭들에 대한 상태를 만들것
/// getProfileBlockit 함수를 사용해서 블럭 데이터를 가져올것
/// user id가 업데이트될때만 다시 호출할것
